import React, { useMemo } from "react";
import styled, { withTheme } from "styled-components";
import { Button } from "../../ui-library/AuthControls/Button";
import EmailSentIcon from "../../../assets/svg/email_sent.svg";

export const StyledIconWrapper = styled.div`
  text-align: center;
`;

export const ModalMessage = styled.p`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  word-wrap: break-word;
`;

const Alert = (props) => {
  const { icon, title, email, callback, message, btnText } = props;

  const modalMessage = useMemo(
    () => message || `We just emailed a confirmation link to ${email}`,
    [email, message]
  );

  return (
    <form onSubmit={callback} className="auth-form" data-testid="alert">
      <StyledIconWrapper className="icon-wrapper">
        <img src={icon || EmailSentIcon} alt={title ? title : "Success"} />
      </StyledIconWrapper>
      <ModalMessage data-testid="alert-message">{modalMessage}</ModalMessage>
      <Button text={btnText || "Home"} />
    </form>
  );
};
export default withTheme(Alert);
